import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { getPaginatedNodes } from "@/utils/getPaginatedNodes"

const graphQLFragments = {
    product: graphql(`
        fragment hasProductTag_Product on Product {
            __typename
            tags(first: 10) {
                edges {
                    node {
                        code
                    }
                }
            }
        }
    `),
}

export function hasProductTag(
    fragment: FragmentOf<typeof graphQLFragments.product>,
    tagCode: string | string[]
) {
    const product = readFragment(graphQLFragments.product, fragment)

    return getPaginatedNodes(product.tags).some((tag) => {
        if (!tag.code) return false

        return typeof tagCode === "string" ? tag.code === tagCode : tagCode.includes(tag.code)
    })
}

hasProductTag.fragments = graphQLFragments
